import { PayloadAction } from '@reduxjs/toolkit';
import { OverlayPayloadActionType, OverlayPayloadReloadTableCallback } from 'src/models/store/overlay';

import { overlaySlice } from 'src/store/overlay/slice';
import { store } from 'src/store/store';

export const dispatchOverlaySliceShow = (data: OverlayPayloadActionType['payload']): PayloadAction =>
  store.dispatch(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    overlaySlice.actions.show(data)
  );

export const dispatchOverlaySliceSetReloadTableCallback = (
  data: OverlayPayloadReloadTableCallback['payload']
): PayloadAction =>
  store.dispatch(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    overlaySlice.actions.setReloadTableCallback(data)
  );

export const dispatchOverlaySliceReload = (data: OverlayPayloadActionType['payload']): PayloadAction =>
  store.dispatch(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    overlaySlice.actions.reloadData(data)
  );
